module.exports = __webpack_public_path__ + "static/img/pdf.49d4041.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icons-actividad/pdf.png
// module id = 217
// module chunks = 1